let scroll_30 = true, scroll_60 = true, scroll_90 = true

const Month = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec'
]

const Months = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
]

const options = { day: 'numeric', month: 'short', year: 'numeric', weekday: 'long' }
const options3 = {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
	hour12: false
}
const options4 = {
	day: 'numeric',
	month: 'short',
	year: 'numeric'
}

function GlobalTeference() {
	var height = jQuery(window).scrollTop();
	if (height > 10) {
		jQuery('html').addClass('shactive');
	} else {
		jQuery('html').removeClass('shactive');
	}
	if (height > 10) {
		$('html').addClass('sticky');
	} else {
		$('html').removeClass('sticky');
	}
	jQuery(window).scroll(function () {
		height = jQuery(window).scrollTop();
		if (height > 10) {
			jQuery('html').addClass('shactive');
		} else {
			jQuery('html').removeClass('shactive');
		}
	});
	const ul = document.querySelector('.menubar > ul');
	ul?.addEventListener('scroll', () => {
		const scrollBottom = ul.scrollTop + ul.clientHeight >= ul.scrollHeight;
		if (scrollBottom) {
			ul.classList.add('scrolled-to-end'); // Add your custom class here
		} else {
			ul.classList.remove('scrolled-to-end');
		}
	});
	const simplebars = document.querySelectorAll('.megaheader [data-simplebar]');

	simplebars.forEach((el) => {
		const simplebarInstance = SimpleBar.instances.get(el) || new SimpleBar(el);
		const scrollElement = simplebarInstance.getScrollElement(); // This is `.simplebar-content-wrapper`

		scrollElement.addEventListener('scroll', () => {
			const scrollTop = scrollElement.scrollTop;
			const scrollHeight = scrollElement.scrollHeight;
			const clientHeight = scrollElement.clientHeight;
			const atBottom = scrollTop + clientHeight >= scrollHeight;

			// You can toggle a class if needed:
			if (atBottom) {
				el.classList.add('scrolled-to-end');
			} else {
				el.classList.remove('scrolled-to-end');
			}
		});
	});
	document.querySelectorAll('.meganav1 a').forEach((tabLink, index) => {
		tabLink.addEventListener('click', function () {
			console.log(11111);

			const targetSelector = tabLink.getAttribute('data-bs-target') || tabLink.getAttribute('href');
			if (!targetSelector) return;

			const targetPane = document.querySelector(targetSelector);
			if (!targetPane) return;

			const el = targetPane.querySelector('.nav[data-simplebar]');
			if (!el) return;

			const simplebarInstance = SimpleBar.instances.get(el) || new SimpleBar(el);
			const scrollElement = simplebarInstance.getScrollElement();
			scrollElement.scrollTop = 0;


		});
	});


	$("body").addClass("loaded");
	//Notice page get auto selected tab
	var u = window.location.href;
	if (u.indexOf('notices') != -1 && u.indexOf('#') != -1) {
		var arr = u.split('#');
		if (typeof (arr[1]) !== "undefined" && arr[1] !== null) {
			$("#notice-tab").val(arr[1]).trigger('change');
			$("a[data-id='" + arr[1] + "'").tab('show');
		}
	}

	if ((u.indexOf('help-itrade') !== -1 || u.indexOf('help-itrade-scroll') !== -1) && u.indexOf('#') !== -1) {
		var arr = u.split('#');
		if (typeof arr[1] !== "undefined" && arr[1] !== null) {
			$("#notice-tab").val(arr[1]).trigger('change');
			$("a[data-id='" + arr[1] + "']").tab('show');
		}
	}

	if (u.indexOf('investment-banking') != -1 && u.indexOf('#') != -1) {
		var arr = u.split('#');
		if (typeof (arr[1]) !== "undefined" && arr[1] !== null) {
			$("#notice-tab").val(arr[1]).trigger('change');
			$("a[data-id='" + arr[1] + "'").tab('show');
		}
	}

	if (u.indexOf('futures') != -1 && u.indexOf('#') != -1) {
		var arr = u.split('#');
		if (typeof (arr[1]) !== "undefined" && arr[1] !== null) {
			$("#notice-tab").val(arr[1]).trigger('change');
			$("a[data-id='" + arr[1] + "'").tab('show');
		}
	}

	if (u.indexOf('pricing-details') != -1 && u.indexOf('#') != -1) {
		var arr = u.split('#');
		if (typeof (arr[1]) !== "undefined" && arr[1] !== null) {
			$("#notice-tab").val(arr[1]).trigger('change');
			$("a[data-id='" + arr[1] + "'").tab('show');
		}
	}

	if (jQuery(".futures-offeringbox").length > 0) {
		if (jQuery(".futures-offeringbox .Offeringbox").length == 1) {
			jQuery(".wpr.futures-offeringbox").addClass("no-h");
		}
	}

	$('a[href^="mailto:"]').on('click', function (e) {
		console.log('GTM 26', `'event': 'outbound_mailto'`, `link_text': ${$(this).text().trim()}`, `'link_url': ${$(this).attr('href')}`);
		gtag('event', 'outbound_mailto', {
			'link_text': $(this).text().trim(),
			'link_url': $(this).attr('href')
		});
	});

	$('a[href^="tel:"]').on('click', function (e) {
		console.log('GTM 25', `'event': 'outbound_tel'`, `link_text': ${$(this).text().trim()}`, `'link_url': ${$(this).attr('href')}`);
		gtag('event', 'outbound_tel', {
			'link_text': $(this).text().trim(),
			'link_url': $(this).attr('href')
		});
	});

	$('.socialicon').find('a').on('click', function (e) {
		console.log('GTM 27', `'event': 'outbound_social'`, `	'link_url': ${$(this).attr('href')}`);
		gtag('event', 'outbound_social', {
			'link_url': $(this).attr('href')
		});
	});


	$('.sharearticle').find('a').on('click', function (e) {
		console.log('GTM 28', `'event': 'share'`, `'method': ${$(this).attr('label')}`);
		gtag('event', 'share', {
			'method': $(this).attr('label'),
		});
	});

	$('.careerstabsec a.nav-link').on('click', function (e) {
		console.log('GTM 29', `'event': 'nav_in_page_click'`, `'link_text': ${$(this).text().trim()}`);
		gtag('event', 'nav_in_page_click', {
			'link_text': $(this).text().trim(),
		});
	});



	$('.nav-tabs-vertical a.nav-link').on('click', function (e) {
		console.log('GTM 30', `'event': 'tab_click'`, `'link_text': ${$(this).text().trim()}`, `'section_title': ${$('.verticaltitle').text().trim()}`);
		gtag('event', 'tab_click', {
			'link_text': $(this).text().trim(),
			'section_title': $('.verticaltitle').text().trim()
		});
	});
	$('.nav-tabs-vertical1 a.nav-link').on('click', function (e) {
		console.log('GTM 30', `'event': 'tab_click'`, `'link_text': ${$(this).text().trim()}`, `'section_title': ${$('.verticaltitle').text().trim()}`);
		gtag('event', 'tab_click', {
			'link_text': $(this).text().trim(),
			'section_title': $('.verticaltitle').text().trim()
		});
	});

	$('.accordion-button').on('click', function (e) {
		console.log('GTM 31', `'event': 'accordion_open'`, `'link_text': ${$(this).text().trim()}`, `'section_title': ${$('.accordion-buttontitle').text().trim()}`);
		gtag('event', 'accordion_open', {
			'link_text': $(this).text().trim(),
			'section_title': $('.accordion-buttontitle').text().trim()
		});
	});
	$('.readbtn').find('a').on('click', function (e) {
		console.log('GTM 35', `'event': 'cta_click'`, `'link_text':${$(this).text().trim()}`, `'link_url':${$(this).attr('href')}`, 'cta_source:sidebar');
		gtag('event', 'cta_click', {
			'link_text': $(this).text().trim(),
			'link_url': $(this).attr('href'),
			'cta_source': 'sidebar'
		});
	});

	$('.subscribesection').find('a').on('click', function (e) {

		gtag('event', 'outbound_tel', {
			'link_text': $(this).text().trim(),
			'link_url': $(this).attr('href')
		});
	});
	$('.h-dropdown').find('a').on('click', function (e) {
		console.log('GTM 47', `'event': 'login_platform'`, `'link_text':${$(this).text().trim()}`, `'link_url':${$(this).attr('href')}`);
		gtag('event', 'login_platform', {
			'link_text': $(this).text().trim(),
			'link_url': $(this).attr('href')
		});
	});


	$(".all-topic-sec .show-btn.show-more").on('click', function (event) {
		event.preventDefault();
		$(this).addClass('d-none');
		$(".show-less").removeClass('d-none');

		$(".all-topic-sec .row .col-md-6.col-lg-4.d-none.d-md-block").removeClass('d-none');

	});
	$(".all-topic-sec .show-btn.show-less").on('click', function (event) {
		event.preventDefault();
		$(this).addClass('d-none');
		$(".all-topic-sec .row .col-md-6.col-lg-4:gt(3)").addClass('d-none');
		$(".show-more").removeClass('d-none');
	});

	$(window).scroll(function () {
		height = $(window).scrollTop();


		if ($('.Insightsbanner').length > 0) {
			// If the 'Insightsbanner' class is found, apply sticky at 20px scroll
			if (height > 10) {
				$('html').addClass('sticky');
			} else {
				$('html').removeClass('sticky');
			}
		} else {
			// If 'Insightsbanner' is not found, use the header sticky logic
			const d = document.getElementById("headersticky");
			const topPos = d.offsetTop - 90;
			if (height > topPos) {
				$('html').addClass('sticky');
			} else {
				$('html').removeClass('sticky');
			}
			//console.log(d.offsetTop);
			if (height == 0) {
				$('html').removeClass('sticky');
			}
		}

		if (jQuery("#myTab").length >= 1) {
			const r = document.getElementById("headersticky");
			if (height > (r.offsetTop - 20)) {
				$('html').addClass('stickytab');
			} else {
				$('html').removeClass('stickytab');
			}
		}

		if (jQuery(".hctab").length >= 1) {
			const r = document.getElementById("headersticky");
			if (height > (r.offsetTop - 20)) {
				$('html').addClass('hctabfix');
			} else {
				$('html').removeClass('hctabfix');
			}
		}

		if (jQuery('#insightstext').length >= 1) {
			var note = document.getElementById("insightstext");
			var screenPosition = note.getBoundingClientRect();
			var topPos = screenPosition.top;
			if (topPos <= 0) {
				$('body').addClass('blogiconshow');
			} else {
				$('body').removeClass('blogiconshow');
			}
		}
		var windowHeight = $(this).height();
		var documentHeight = $(document).height();

		// 计算当前滚动百分比 (0-100)
		var scrollPercent = (height / (documentHeight - windowHeight)) * 100;


		if (scrollPercent >= 30 && scrollPercent < 60) {
			// 滚动到30%位置

			if (scroll_30) {
				console.log('GTM 30 22');
				gtag('event', 'scroll', {
					'percent_scrolled': '30'
				});
				scroll_30 = false
			}

		} else if (scrollPercent >= 60 && scrollPercent < 90) {
			// 滚动到60%位置
			if (scroll_60) {
				console.log('GTM 60 22');
				gtag('event', 'scroll', {
					'percent_scrolled': '60'
				});
				scroll_60 = false
			}

		} else if (scrollPercent >= 90) {
			// 滚动到90%位置
			if (scroll_90) {
				console.log('GTM 90 22');
				gtag('event', 'scroll', {
					'percent_scrolled': '90'
				});
				scroll_90 = false
			}

		}





	});
	$("form .filterwpr label input[type='checkbox'],form .filterwpr label input[type='radio']").change(function () {
		if ($("form .filterwpr label input[type='checkbox']:checked").length > 0 || $("form .filterwpr label input[type='radio']:checked").length > 0) {
			// jQuery(this).closest('form').find('.filterbtn').find('button').removeAttr('disabled');
			if (jQuery(this).val() == 'All') {

				if (this.checked) {
					jQuery(this).closest('.filterwpr').find('label').find('input[type="checkbox"]').attr("checked", 'checked');
					jQuery(this).closest('.filterwpr').find('label').find('input[type="checkbox"]').prop("checked", true);
				} else {
					jQuery(this).closest('.filterwpr').find('label').find('input[type="checkbox"]').prop("checked", false);
				}
			}
		} else {
			// jQuery(this).closest('form').find('.filterbtn').find('button').prop('disabled', true);
		}
	});
	$("form button[type='reset']").not("form.search-form button[type='reset'],.searchbox button[type='reset']").click(function (event) {
		var attr = $(this).attr('data-result');
		if (typeof attr !== 'undefined' && attr !== false) {
			jQuery(this).closest('form').find('.filterwpr').find('label').find('input[type="checkbox"]').prop("checked", false);
		} else {

			jQuery(this).closest('form').find('.filterwpr').find('label').find('input[type="checkbox"]').prop("checked", false);
			// jQuery(this).closest('form').find('button[type="submit"]').prop('disabled', true);
			// jQuery(this).closest('form').find('button[type="reset"]').prop('disabled', true);
		}
		event.preventDefault()
	});

	$('#componentform select').change(function () {
		var hvalue = jQuery(this).val()
		$('#componentform').attr('action', hvalue).attr('target', '_blank')
		this.form.submit();
	});
	$('.select2').select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState
	});
	$('#notice-tab,#igniteyourc').select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#dropdownpar')
	});

	$("#igniteyourc").select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#dropdownpar1')
	});

	$("#igniteyourc2").select2({
		placeholder: "Country (Tax Residence)",
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#dropdownpar1')
	});
	$("#pn-select1").select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#pn-select')
	});


	$('#notice-tab').select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#dropdownpar')
	});

	$("#footer-select").select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#footer-select1')
	});
	$("#select-outline").select2({
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		dropdownParent: $('#select-outline1')
	});
	$('#sc-form').change(function () {
		$(this).submit();
	});


	function formatState(opt) {


		if (!opt.id) {
			return opt.text;
		}

		var optimage = $(opt.element).attr('data-image');
		if (!optimage) {
			return opt.text;
		} else {
			var $opt = $(
				'<span><img src="' + optimage + '" width="60px" alt="Flag" /> ' + opt.text + '</span>'
			);
			return $opt;
		}
	};


	$('#filter,.awardsfilter').click(function () {
		$('body').addClass('filtershow');
	});


	$('#shortbymb').click(function () {
		$('body').addClass('shortbyshow');
	});
	$('.filterback,.overlay').click(function () {
		$('body').removeClass('filtershow');
	});


	$('.filterback').click(function () {
		$('body').removeClass('shortbyshow');
	});
	$('.mfilters .filtername,.mfilters .icon').click(function () {
		$(this).parent().parent().toggleClass('mfiltershow');
	});
	$('.mbawardsfilter .mfilters').click(function () {
		$(this).toggleClass('mfiltershow');
	});
	$('.salllabel').click(function () {
		$(this).parent().toggleClass('seealllabel');
	});
	$('.togglemenu').click(function () {


		$('body').toggleClass('menushow');
		$('body').removeClass('searchopen');
		$('.h-dropdown-wrap').removeClass('dshow');
	});
	$(document).click(function () {
		$('li.menuparent').removeClass('submenumenushow');
	});
	// $('li.menuparent > a').click(function (e) {
	// 	e.preventDefault();
	// 	e.stopPropagation();
	// 	let $parent = $(this).parent();
	// 	$parent.toggleClass('submenumenushow')
	// 		.siblings('.menuparent').removeClass('submenumenushow');
	// 	jQuery('body').removeClass('megashow');
	// 	console.log(2222);

	// });
	$('li.menuparent').click(function (e) {
		e.stopPropagation();
	});
	// setTimeout(() => {
	// 	$('li.menuparent > .submenu-toggle').click(function () {
	// 		$(this).parent().toggleClass('submenumenushow')
	// 			.siblings('.menuparent').removeClass('submenumenushow');
	// 	});
	// }, 1000)

	$('.dropdowncontent .icon').click(function () {
		$(this).parent().toggleClass('active');
	});
	$('.anchordropdown h6').click(function () {


		$(this).parent().toggleClass('anchorshow');
	});

	$('.mbawardsfilter .mfilters').click(function () {
		$(this).toggleClass('mfiltershow');
	});

	jQuery(".Discoverboxwpr").mouseover(function () {
		jQuery("[class*='col-']:first-child .Discoverbox").removeClass('active');
	});
	jQuery(".Discoverboxwpr").mouseout(function () {
		jQuery("[class*='col-']:first-child .Discoverbox").addClass('active');
	});
	// jQuery(".Discoverboxwpr [class*='col-']").mouseover(function () {
	// 	jQuery(".Discoverboxwpr [class*='col-'] .Discoverbox").removeClass('active');
	// 	if (jQuery(this).length != 0) {
	// 		jQuery(this).child().addClass('active');
	// 	}


	// });
	jQuery(".Discoverboxwpr").mouseout(function () {
		jQuery(".Discoverboxwpr [class*='col-']:first-child .Discoverbox").addClass('active');
	});

	$('.blogsidebaricon').click(function () {
		$('body').addClass('sidebarshow');
	});
	$('.closeicon').click(function () {
		$('body').removeClass('sidebarshow');
	});
	$('.announcementbar .closeicon').click(function () {
		$(this).parent().parent().addClass('hide');
	});
	$('.contentlist a').click(function () {
		$('body').removeClass('sidebarshow');
	});

	$('.innermenu').click(function () {
		//$(this).toggleClass('subpages-show');
	});
	$('li.innermenu').on('click', function (event) {
		if (event.target === this) {
			$(this).toggleClass('subpages-show');
		}
	});
	$('li.innermenu .icon').on('click', function (event) {
		if (event.target === this) {
			$(this).parent().toggleClass('subpages-show');
		}
	});
	$('.mpagetoggle').click(function () {
		$('body').addClass('mpage-show').addClass('zindex');
	});
	$('.mpageclose,.overlay').click(function () {
		$('body').removeClass('mpage-show');
		setTimeout(function () {
			$('body').removeClass('zindex');
		}, 400);
	});


	$(".search").click(function () {
		$("body").toggleClass('searchopen');
		$("body").removeClass('lngncnboxopen');
		$("body").removeClass('submenumenushow');
	});
	// $(".lngncnbox").click(function () {
	// 	$("body").toggleClass('lngncnboxopen');
	// 	$("body").removeClass('megashow');
	// 	$("body").removeClass('searchopen');
	// 	$(".h-dropdown-wrap").removeClass('dshow');
	// 	$(".hoverlay").toggleClass('show');
	// });

	$(".hoverlay").click(function () {
		$("body").removeClass('lngncnboxopen');
		$("body").removeClass('megashow');
		$("body").removeClass('searchopen');
		$(".h-dropdown-wrap").removeClass('dshow');
		$(this).removeClass('show');
	});



	$(".mlng_toggle").click(function () {
		jQuery(".mega_mlngdropdown").addClass('show');
	});
	$(".mlng_toggle").click(function () {
		jQuery(".mega_mlngdropdown").addClass('show');
	});
	$(".maintenancebar .closeicon").click(function () {
		$(".maintenancebar").addClass('mhide');
	});
	$("#caccept").click(function () {
		$(".cookiesbox").addClass('d-none');
	});
	$(".languagebox .box").click(function () {
		$('.landetailbox').removeClass('d-none');
	});
	$(".backbtn").click(function () {
		$(this).parent().addClass('d-none');
	});
	$(".disclaimer-rm").click(function () {
		$(this).parent().toggleClass('c-show');
	});
	$("#shortby").click(function () {
		$("#sb").select2('open');
		$(".select2-container--open").addClass("showfilter");
	});
	$('#sb').on('select2:open', function (e) {
		jQuery("body").toggleClass("sel2cls");
	});
	// $('#notice-tab').on('select2:select', function (e) {
	// 	var data = e.params.data;
	// 	var i = data.id;
	// 	//var t = data.text;
	// 	$("a[data-id='" + i + "'").tab('show');
	// 	//$("ol.breadcrumb li:last").text(t);
	// 	if (jQuery('.table-scroll').length > 0) {
	// 		new SimpleBar(jQuery('#' + i + ' .table-scroll')[0]);
	// 	}
	// 	var path = window.location.pathname;


	// });

	// $('a[data-bs-slug="slug"]').on('show.bs.tab', function (e) {
	// 	var i = $(e.target).attr("data-id");
	// 	var t = $(e.target).text();
	// 	if (!$('body').hasClass('help-itrade-page')) {
	// 		$("ol.breadcrumb li:last").text(t);
	// 	}
	// 	var path = window.location.pathname;
	// 	var page = path.split("/").pop();

	// 	history.pushState(null, null, page + '#' + i);
	// });


	$(".showfilter").click(function () {
		var targetId = jQuery('#headersticky').attr('href');
		var offset = 100; // Adjust this value as needed
		jQuery('html, body').animate({
			scrollTop: jQuery(targetId).offset().top - offset
		}, 500);
	});
	jQuery("input[name='short_by']").change(function () {
		jQuery("#sitem").text(jQuery(this).val());
		jQuery(".filterback").trigger("click");
		$('html, body').animate({
			scrollTop: $('#headersticky').offset().top - 20
		}, 500);
	});
	jQuery("select#sb").change(function () {
		jQuery("body").removeClass("sel2cls");
		$('html, body').animate({
			scrollTop: $('#headersticky').offset().top - 20
		}, 500);
	});
	$('.searchwpr .form-control,.searchbox .form-control').on('input', function () {
		var inputVal = $(this).val();
		if (inputVal.trim() === "") {
			$('.searchwpr button[type="reset"],.searchbox button[type="reset"]').addClass('d-none');
		} else {
			$('.searchwpr button[type="reset"],.searchbox button[type="reset"]').removeClass('d-none');
		}
	});
	$('.searchwpr button[type="reset"],.searchbox button[type="reset"]').click(function () {
		$('.searchwpr .form-control,.searchbox .form-control').val('').attr('value', '');
		$(this).addClass('d-none');
	});


	/* Contact page JS Start */
	function checkInputs(e) {

		const allFilled = $('.contact-section input[type="text"]').val().trim() !== "" &&
			$('.contact-section select').val().trim() !== "" &&
			$('.contact-section .enquirychecks input[type="checkbox"]').val().trim() !== "" &&
			$('.contact-section .ppchecks  input[type="checkbox"]').val().trim() !== "" &&
			$('.contact-section input[type="email"]').val().trim() !== "" &&
			$('textarea[name="assist"]').val().trim() !== '';


		if (e.target.name == 'ppolicy' || e.target.name == 'updates') {
			$(".form-checks.ppchecks").removeClass('error');
		}

		if (e.target.className == 'inv') {
			$(".form-checks.enquirychecks").removeClass('error');
		}
		if (e.target.value !== "") {
			e.target.classList.remove('error');
		}

		if (e.target.type == 'email') {
			var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
			if (!pattern.test(e.target.value)) {
				$("#email").addClass('error');
			}
		}
		if (allFilled) {
			$('.form-submit button').removeClass('disabled');
		} else {
			$('.form-submit button').addClass('disabled');
		}
	}

	// Add input event listener to all fields
	$('.contact-section input[type="text"], .contact-section select,.contact-section textarea, .contact-section .ppchecks input[type="checkbox"], .contact-section input[type="email"],.contact-section .enquirychecks input[type="checkbox"]').on('input', checkInputs);

	// Prevent form submission for demonstration
	$('.contact-section form').on('submit', function (event) {
		event.preventDefault();
		const allFilled = $('.contact-section input[type="text"]').val().trim() !== "" &&
			$('.contact-section select').val().trim() !== "" &&
			$('.contact-section input[type="checkbox"]').val().trim() !== "" &&
			$('.contact-section input[type="email"]').val().trim() !== "";

		if (allFilled) {

			return true;
		} else {

			return false;
		}
	});

	jQuery(document).on("change", ".contactform input.form-control", function () {
		if (jQuery(this).val() != '') {
			jQuery(this).parent().addClass('ac');
		} else {
			jQuery(this).parent().removeClass('ac');
		}
	});
	jQuery(document).on("change", "#igniteyourc2", function () {
		if (jQuery(this).val() != '') {
			jQuery(this).parent().addClass('ac');
		} else {
			jQuery(this).parent().removeClass('ac');
		}
	});



	/* Contact page JS End */


	if (jQuery(window).width() < 767) {
		jQuery('.timeline-carousel .splide .splide__slide:last').remove();

		if (jQuery('.awardcarousel .item').length > 1) {
			jQuery('.awardcarousel .item:last').remove();
		}
		jQuery('.awardcarousel3 .item:last').remove();
		if (jQuery('.table-scroll').length > 0) {
			new SimpleBar(jQuery('.table-scroll')[0]);
		}
		if (jQuery('figure.table').length > 0) {
			jQuery(jQuery('figure.table')).addClass('table-scroll').attr('data-simplebar');
			new SimpleBar(jQuery('.table-scroll')[0]);
		}
		$(".menuparent").click(function () {
			$('.submenu .d-none').removeClass('d-none');
		});
		$(".business_tab_wrp ul.nav-tabs li").each(function () {
			var at = $(this).find('a').attr('data-bs-target');
			$(this).find('a').after($(at));

		});

		$('.advisory_services_carousel').wrap('<div class="carousel-wpr"></div>');
	};
	if (jQuery(window).width() < 1025) {
		jQuery('.lastremove .item:last').remove();
		jQuery('.cgsi-international .item:last').remove();
		jQuery('.supportboxcarousel .item:last').remove();
		jQuery('.advance_journey_progress_section .splide .splide__slide:last').remove();

	};

	// $('.slider_career_country').owlCarousel({
	// 	loop: false,
	// 	margin: 0,
	// 	items: 1,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// });
	// $('.tradebox5-carousel').owlCarousel({
	// 	loop: false,
	// 	margin: 0,
	// 	items: 4,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			center: true,
	// 			nav: false,
	// 			dots: true
	// 		},
	// 		768: {
	// 			items: 3
	// 		},
	// 		992: {
	// 			items: 4
	// 		}
	// 	}
	// });
	// $('.tradebox-carousel').owlCarousel({
	// 	loop: false,
	// 	margin: 0,
	// 	items: 4,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			center: true,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 3
	// 		},
	// 		992: {
	// 			items: 4
	// 		}
	// 	}
	// });

	//Center item logic
	if ($('.tradebox-carousel').length > 0 && $('.tradebox-carousel').data('owl.carousel').items().length <= 3) {
		$('.tradebox-carousel').addClass("c_owl");
	}

	const awardCarousel = document.querySelector('.awardcarousel');
	const items = document.querySelectorAll('.awardcarousel .item');

	if (awardCarousel && items.length <= 3) {
		awardCarousel.classList.add('c_owl');

		const lastItem = items[items.length - 1];
		if (lastItem && lastItem.children.length === 0) {
			lastItem.remove();
		}
	}

	// $('.awardcarouselarrows').owlCarousel({
	// 	loop: false,
	// 	margin: 32,
	// 	items: 3,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			center: true,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 1,
	// 			margin: 20
	// 		},
	// 		992: {
	// 			items: 3
	// 		}
	// 	}
	// });

	// $('.awardcarousel').owlCarousel({
	// 	loop: false,
	// 	margin: 32,
	// 	items: 2,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			center: true,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 1,
	// 			margin: 20
	// 		},
	// 		992: {
	// 			items: 2
	// 		}
	// 	}
	// });
	// $('.awardcarousel3').owlCarousel({
	// 	loop: false,
	// 	margin: 0,
	// 	items: 3,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			center: true,
	// 			margin: 6,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 2,
	// 			margin: 0
	// 		},
	// 		992: {
	// 			items: 3
	// 		}
	// 	}
	// });


	// 	$('.InsightsCarouselE').owlCarousel({
	// 	loop: false,
	// 	margin: 16,
	// 	items: 4,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 3,
	// 			center: true,
	// 			margin: 6,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 3,
	// 			margin: 24
	// 		},
	// 		992: {
	// 			items: 4
	// 		}
	// 	}
	// });

	// $('.InsightsCarousel').owlCarousel({
	// 	loop: false,
	// 	margin: 16,
	// 	items: 4,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 3,
	// 			center: true,
	// 			margin: 6,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 3,
	// 			margin: 24
	// 		},
	// 		992: {
	// 			items: 4
	// 		}
	// 	}
	// });

	//Center item logic
	// if ($('.InsightsCarousel').length > 0 && $('.InsightsCarousel').data('owl.carousel').items().length <= 3) {
	// 	$('.InsightsCarousel').addClass("c_owl");
	// }


	// $('.commentarycarousel').owlCarousel({
	// 	loop: false,
	// 	margin: 40,
	// 	items: 1,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			center: true,
	// 			margin: 10,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		768: {
	// 			items: 1,
	// 			margin: 20
	// 		},
	// 		992: {
	// 			items: 1
	// 		}
	// 	}
	// });


	if ($(".filterv2")[0]) {
		$(document).click(function (e) {
			var container = $("#shortby");
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				$('body').removeClass('sel2cls');
			}
		});
	}

	//Event ongoing / Past
	if (jQuery("div").hasClass("event_ongoing_wrp")) {
		$('#notice-tab').on('select2:select', function (e) {

			var data = e.params.data;
			var idid = "#" + data.id;

			jQuery(".pmenuanchor,.accordion-collapse").removeClass('show');
			jQuery("button.accordion-button").attr('aria-expanded', "false");
			//console.log(jQuery('button[data-bs-target="'+idid+'"]').trigger("click"));
			var targetId = "#accordionExample";
			var offset = 100; // Adjust this value as needed
			jQuery('html, body').animate({
				scrollTop: jQuery(targetId).offset().top - offset
			}, 500);

		});
	}

	//Breadcrumb Logic here

	if (jQuery("ol.breadcrumb li").length > 2) {
		jQuery("ol.breadcrumb li").click(function () {
			var attr = jQuery(this).find("a").attr('data-title');
			if (typeof attr !== 'undefined' && attr !== false) {
				jQuery("ol.breadcrumb li:last").attr('data-title', "...");
				jQuery("ol.breadcrumb li").find("a").attr("data-title", "...");
				var totalLen = jQuery("ol.breadcrumb li").length;
				var cunIn = jQuery(this).index();
				var ind = parseInt(jQuery(this).index()) + 1;
				jQuery("ol.breadcrumb li:eq(" + cunIn + ") a,ol.breadcrumb li:eq(" + ind + ") a").removeAttr('data-title');
				if (parseInt(totalLen) == parseInt(ind) + 1) {
					jQuery("ol.breadcrumb li:last").removeAttr('data-title');
				}
				var f = jQuery("ol.breadcrumb li:eq(0)").find("a").attr('data-title');
				var s = jQuery("ol.breadcrumb li:eq(1)").find("a").attr('data-title');

				var f1 = jQuery("ol.breadcrumb li:nth-last-child(2)").find("a").attr('data-title');
				var s1 = jQuery("ol.breadcrumb li:nth-last-child(2)").find("a").attr('data-title');

				if ((typeof f1 !== 'undefined' && f1 !== false) && (typeof s1 !== 'undefined' && s1 !== false)) {
					jQuery("ol.breadcrumb li:last").addClass('d-none');
				} else {
					jQuery("ol.breadcrumb li:last").removeClass('d-none');
				}

				if ((typeof f !== 'undefined' && f !== false) && (typeof s !== 'undefined' && s !== false)) {
					jQuery("ol.breadcrumb li:eq(0)").addClass('d-none');
				} else {
					jQuery("ol.breadcrumb li:eq(0)").removeClass('d-none');
				}

			} else {
				//Redirect if Link
				if (jQuery(this).find("a").length == 0) {
					jQuery("ol.breadcrumb li").find("a").attr("data-title", "...");
					jQuery("ol.breadcrumb li:last").removeAttr('data-title');
					jQuery("ol.breadcrumb li:nth-last-child(2) a").removeAttr('data-title');
				}
				var f = jQuery("ol.breadcrumb li:eq(0)").find("a").attr('data-title');
				var s = jQuery("ol.breadcrumb li:eq(1)").find("a").attr('data-title');
				if ((typeof f !== 'undefined' && f !== false) && (typeof s !== 'undefined' && s !== false)) {
					jQuery("ol.breadcrumb li:eq(0)").addClass('d-none');
				} else {
					jQuery("ol.breadcrumb li:eq(0)").removeClass('d-none');
				}
				return true;
			}
			return false;
		});
	}



	document.querySelectorAll('.closetabs .tab-pane').forEach(function (pane) {
		pane.classList.remove('active'); // Ensure no pane is active on load
	});

	let currentTab = null;

	// Add click event listener to each tab
	document.querySelectorAll('.closetabs .nav-link').forEach(function (tab) {
		tab.addEventListener('click', function (e) {
			e.preventDefault();
			const targetPane = document.querySelector(this.getAttribute('data-bs-target'));
			if (currentTab === this) {
				// If the same tab is clicked, close the tab
				currentTab = null;
				this.classList.remove('active');
				targetPane.classList.remove('active', 'show');
			} else {
				// Open the clicked tab and close others
				if (currentTab) {
					currentTab.classList.remove('active');
					document.querySelector(currentTab.getAttribute('data-bs-target')).classList.remove('active', 'show');
				}
				currentTab = this;
				this.classList.add('active');
				targetPane.classList.add('active', 'show');
			}
		});
	});


	document.querySelectorAll('.loadmore-btn').forEach(button => {
		button.addEventListener('click', function () {
			const tabPane = this.closest('.tab-pane');
			tabPane.querySelectorAll('.col-md-6').forEach(element => {
				element.classList.remove('d-none');
			});
			this.classList.add('d-none');
		});
	});
	if (document.querySelector('.insight-sm-carousel')) {
		document.querySelector('.insight-sm-carousel .items-lm')?.addEventListener('click', function () {
			document.querySelectorAll('.insight-sm-carousel .col-md-4.d-none').forEach(function (element) {
				element.classList.remove('d-none');
			});

			document.querySelector('.insight-sm-carousel .btn-wpr')?.classList.add('d-none');
		});
	}
	if (typeof window.disableSimpleBar === 'undefined') {
		window.disableSimpleBar = false;
	}
	if (!window.disableSimpleBar && document.querySelectorAll("figure.table").length > 0) {
		if (document.querySelectorAll("figure.table").length > 0) {
			document.querySelectorAll("figure").forEach((el, index) => {
				el.setAttribute('data-simplebar', 'true');
				if (index > 0) {
					setTimeout(function () {
						new SimpleBar(el);
					}, 500);
				}
			});
		}
	}
	// MegaMenu
	$(".mega_toggle").click(function () {
		$("body").toggleClass('megashow');
		$("body").removeClass('lngncnboxopen');
		$("body").removeClass('searchopen');
		$(".h-dropdown-wrap").removeClass('dshow');
		$(".hoverlay").toggleClass('show');
	});
	$(".search_toggle").click(function () {
		$("body").toggleClass('searchopen');
		$("body").removeClass('megashow');
		$("body").removeClass('lngncnboxopen');
		$("body").removeClass('menushow');
		$(".h-dropdown-wrap").removeClass('dshow');
		$(".hoverlay").toggleClass('show');
	});

	// $(".h-dropdown-wrap > a").click(function () {
	// 	$(this).parent().toggleClass('dshow');
	// 	$("body").removeClass('lngncnboxopen');
	// 	$("body").removeClass('megashow');
	// 	$("body").removeClass('menushow');
	// 	$("body").removeClass('searchopen');
	// 	$(".hoverlay").toggleClass('show');
	// });
	$(".hoverlay").click(function () {
		$("body").removeClass('lngncnboxopen');
		$("body").removeClass('megashow');
		$("body").removeClass('searchopen');
		$(".h-dropdown-wrap").removeClass('dshow');
		$(this).removeClass('show');
	});
	$(".mlng_toggle").click(function () {
		jQuery(".mega_mlngdropdown").addClass('show');
	});
	$(".mlng_toggle").click(function () {
		jQuery(".mega_mlngdropdown").addClass('show');
	});
	$(".mback-btn").click(function () {
		jQuery("body").removeClass('megashow');
	});

	if (document.getElementById('form')) {
		document.getElementById('form')?.addEventListener('submit', function (e) {
			e.preventDefault();
		})
	}
}



export default {

	TimeCycle: function (Time, num) {
		if (Time == ' ')
			return "";

		const date = new Date(Time)
		let D = date.getDate()
		let M = num == 0 ? Month[date.getMonth()] : Months[date.getMonth()]
		let Y = date.getFullYear()



		return num == 0 ? `${M} ${D >= 10 ? D : '0' + D}, ${Y}` : `${D >= 10 ? D : '0' + D} ${M} ${Y}`
	},

	TimeCycleA: (StartTime, EndTime) => {


		const Startdate = new Date(StartTime)
		const Enddate = new Date(EndTime)
		const Nowdate = new Date()
		let data = null
		if (Startdate.getTime() <= Nowdate.getTime() <= Enddate.getTime()) {
			data = true
		} else {
			data = false
		}
		return data
	},
	TimeCycleDays: (start, listing) => {
		const startdate = new Date(start)
		const listingdate = new Date(listing)
		const differenceInDays = (listingdate - startdate) / (1000 * 60 * 60 * 24)

		return differenceInDays + 1
	},
	DateToWeekday: (data) => {

		if (!data)
			return "";
		let dataS = new Date(Date.parse(data)).toLocaleDateString('en-GB', options)
		dataS = `${dataS.split(' ')[1]} ${dataS.split(' ')[2]} ${dataS.split(' ')[3]}, ${dataS.split(' ')[0]}`
		return dataS
	},

	DateToWeekday2: (data) => {

		if (!data)
			return "";
		const date = new Date(Date.parse(data))
		// 使用 toLocaleDateString 获取各部分的数字/英文值
		const day = date.toLocaleDateString('en-GB', { day: 'numeric' })
		const monthIndex = date.getMonth() // 0-11
		const year = date.getFullYear()
		const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' })

		// 用你的 Month 数组替换月份
		return `${day} ${Month[monthIndex]} ${year}`


	},
	DateToWeekday3: (data) => {

		if (!data)
			return "";
		const date = new Date(Date.parse(data));

		// 手动构建格式：DD Mon YYYY HH:mm:ss
		const day = String(date.getDate());
		const month = Month[date.getMonth()];
		const year = date.getFullYear();
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');

		return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;

	},
	DateToWeekday4: (data) => {

		if (!data)
			return "";
		let dataS = new Date(Date.parse(data)).toLocaleDateString('en-GB', options4)


		return dataS
	},
	IsNull: (data) => {
		if (data == null || data == 'undefined' || data == '-') {
			return ''
		} else {
			return data
		}
	},
	checkUrl: (url) => {
		if (url) {
			if (url.indexOf('http') != -1) {
				return url
			} else {
				return `/${url}`
			}
		} else {
			return url
		}

	},
	LocationUrl: (lang, LANGUAGE1, LANGUAGE2) => {
		console.log(lang, LANGUAGE1, LANGUAGE2);

		let url = new URL(window.location.href);
		let params = new URLSearchParams(url.search);


		params.set('lang', lang == 1 ? LANGUAGE1 : LANGUAGE2);

		url.search = params.toString();
		// window.location.href = url.toString();
		history.pushState({}, '', url.toString());
	},
	generateId(str) {
		if (!str) return '';
		const decoded = decodeURIComponent(str);
		return decoded
			.replace(/[ @#$%:"]/g, '_')  // 匹配空格和 @ # $ % 
			.replace(/_+/g, '_');      // 合并连续的下划线
	}
}
document.addEventListener('DOMContentLoaded', () => {
	// 等待所有资源加载完成
	window.addEventListener('load', () => {
		// 延迟执行确保所有DOM渲染完成
		requestAnimationFrame(() => {
			// 你的动画初始化代码
			GlobalTeference()
		})
	})
})

